import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useStyles } from './style'
import _ from 'lodash'
import Calendar from '../../elements/calendar'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import { useParams } from 'react-router-dom'
import { systemsService } from '../../Services/SystemsService/SystemsService'
import * as messageTypes from '../../utils/messageTypes'
import { DisplayMessage, Loader } from '../../Components'
import moment from 'moment'
import { Select, MenuItem, Box, Typography, FormControl } from '@material-ui/core'

function CalendarView(props) {
  const classes = useStyles()

  const [startDate, setStartDate] = useState()
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [events, setEvents] = useState([])
  const [open, setOpen] = useState()
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(true)
  const [selectedYear, setYear] = useState('')
  const [yearList, setYearList] = useState([])
  const [enableNext, setEnableNext] = useState(false)
  const [enablePrev, setEnablePrev] = useState(true)

  const { programId, siteId } = useParams()
  const { systemDetails } = props

  useEffect(() => {
    const { enrollment_date } = props.systemDetails
    const currentYear = moment().tz(props.timeZone).format('YYYY')
    const currentDate = moment().tz(props.timeZone).endOf('month').format('YYYY/MM/DD HH:mm:ss')
    const startMonth = moment(`01-01-${selectedYear}`, 'MM-DD-YYYY').format('YYYY-MM-DD HH:mm:ssZ')
    if (moment(enrollment_date, 'YYYY/MM/DD HH:mm:ss').tz(props.timeZone).isSameOrBefore(moment(fromDate, 'YYYY-MM-DD HH:mm:ssZ')) && moment(startMonth).isBefore(moment(fromDate, 'YYYY-MM-DD HH:mm:ssZ'))) {
      setEnablePrev(true)
    } else {
      setEnablePrev(false)
    }

    if (parseInt(selectedYear) === parseInt(currentYear)) {
      if (moment(currentDate).isAfter(moment(toDate))) {
        setEnableNext(true)
      } else {
        setEnableNext(false)
      }
    } else {
      const endMonth = moment(`12-01-${selectedYear}`, 'MM-DD-YYYY').format('YYYY-MM-DD HH:mm:ssZ')
      if (moment(endMonth).isAfter(moment(toDate))) {
        setEnableNext(true)
      } else {
        setEnableNext(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, toDate])

  useEffect(() => {
    const { enrollment_date } = props.systemDetails
    const custom_enrollment_date = moment(enrollment_date).format('YYYY/MM') + '/' + moment().format('DD')
    const currentYear = moment().tz(props.timeZone).format('YYYY')
    if (parseInt(selectedYear) === parseInt(currentYear)) {
      const diff = moment().diff(moment(custom_enrollment_date), 'month')
      let startMonth = (diff > 2 || diff < 0) ? moment().startOf("month").subtract(2, 'M').format('YYYY-MM-DD HH:mm:ssZ') : moment().startOf("month").subtract(diff, 'M').format('YYYY-MM-DD HH:mm:ssZ')
      const endMonth = moment().endOf('month').format('YYYY-MM-DD HH:mm:ssZ')
      if (moment(startMonth).format('YYYY') !== currentYear) {
        startMonth = moment(currentYear).startOf('year').format('YYYY-MM-DD HH:mm:ssZ')
      }
      setFromDate(startMonth)
      setToDate(endMonth)
      setStartDate(moment(startMonth))
    } else {
      let startMonth = moment(`01-01-${selectedYear}`, 'MM-DD-YYYY').format('YYYY-MM-DD HH:mm:ssZ')
      startMonth = moment(enrollment_date, 'YYYY/MM/DD HH:mm:ss').isSameOrBefore(startMonth) ? startMonth : moment(enrollment_date, 'YYYY/MM/DD HH:mm:ss').startOf("month").format('YYYY-MM-DD HH:mm:ssZ')
      let endMonth = moment(`12-01-${selectedYear}`, 'MM-DD-YYYY').format('YYYY-MM-DD HH:mm:ssZ')
      const nextMonth = moment(startMonth).add(2, 'M').endOf("month").format('YYYY-MM-DD HH:mm:ssZ')
      endMonth = moment(endMonth).isSameOrBefore(nextMonth) ? endMonth : nextMonth
      setFromDate(startMonth)
      setToDate(endMonth)
      setStartDate(moment(startMonth))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedYear])

  useEffect(() => {
    const { enrollment_date } = props.systemDetails
    const startYear = moment(enrollment_date, 'YYYY/MM/DD HH:mm:ss').tz(props.timeZone).format('YYYY')
    const currentYear = moment().tz(props.timeZone).format('YYYY')
    let constructedData = []
    let initialYear = parseInt(startYear)
    while (initialYear <= currentYear) {
      constructedData.push({
        name: initialYear,
        start_date: initialYear === parseInt(startYear) ? moment(startDate, 'MM-DD-YYYY').tz(props.timeZone).startOf('month').format('MM-DD-YYYY') : `01-01-${initialYear}`,
        end_date: initialYear === parseInt(currentYear) ? moment().tz(props.timeZone).format('MM-DD-YYYY') : `12-31-${initialYear}`,
        year: initialYear
      })
      initialYear++
    }

    constructedData = constructedData.sort((x, y) => y.year - x.year)
    setYearList(constructedData)
    setYear(_.first(constructedData).name)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.systemDetails])

  const getCalendarData = () => {
    const { currentUser } = props
    setLoading(true)
    systemsService.getCalendarEvents(currentUser.account_id, programId, siteId, fromDate, toDate)
      .then(calendarData => {
        setLoading(false)
        const events = calendarData.events.map((event, index) => {
          return { ...event, start_date_time: event.start_time, end_date_time: event.end_time }
        })
        setEvents(events)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const prevArrowPressed = () => {
    setStartDate(moment(startDate).subtract(1, 'M'))
    setFromDate(moment(startDate).subtract(1, 'M').startOf('month').format('YYYY-MM-DD HH:mm:ssZ'))
    setToDate(moment(startDate).subtract(1, 'M').add(2, 'M').endOf("month").format('YYYY-MM-DD HH:mm:ssZ'))
  }

  const nextArrowPressed = () => {
    setStartDate(moment(startDate).add(1, 'M'))
    setFromDate(moment(startDate).add(1, 'M').startOf('month').format('YYYY-MM-DD HH:mm:ssZ'))
    setToDate(moment(startDate).add(1, 'M').add(2, 'M').endOf("month").format('YYYY-MM-DD HH:mm:ssZ'))
  }

  useEffect(() => {
    getCalendarData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, toDate])

  const DropDownView = () => {
    return (
      <Box className={classes.selectWrapper}>
        <Typography className={classes.sortTitle}>Sort By</Typography>
        <FormControl>
          <Select
            value={selectedYear}
            onChange={(event) =>
              setYear(event.target.value)
            }
            classes={{ select: classes.dropDownRoot, underline: classes.underline }}
          >
            {yearList.map((obj) => {
              return <MenuItem value={obj.name}>{obj.name}</MenuItem>
            })}
          </Select>
        </FormControl>
      </Box>
    )
  }

  return (
    <>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <DropDownView />
      <Box className={classes.calendarAlignment}>
        <div className={classes.arrowIcon}><ArrowBackIosIcon className={!enablePrev && classes.disabledArrow} onClick={() => enablePrev && prevArrowPressed()} /></div>
        <Calendar startDate={startDate} endDate={moment(toDate)} EventsList={events} timeZone={props.timeZone} programId={programId} enrollmentDate={systemDetails && systemDetails.enrollment_date} />
        <div className={classes.arrowIcon}><ArrowForwardIosIcon className={!enableNext && classes.disabledArrow} onClick={() => enableNext && nextArrowPressed()} /></div>
      </Box>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, timeZone } = auth
  return { currentUser, timeZone }
}

export default connect(mapStateToProps, {})(CalendarView)